import * as React from 'react';

import ProgramSkillRecommendationsPageRootContent from 'bundles/program-skills-objectives/pages/ProgramSkillRecommendationsPageRootContent';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterprisePageDataProvider from 'bundles/unified-common/providers/EnterprisePageDataProvider';
import EnterprisePageTrackingWrapper from 'bundles/unified-home-common/pages/enterprise/EnterprisePageTrackingWrapper';

const ProgramSkillSetRecommendationsPageRoot = () => {
  return (
    <EnterprisePageDataProvider>
      <EnterprisePageTemplateWrapper>
        <EnterprisePageTrackingWrapper>
          <ProgramSkillRecommendationsPageRootContent />
        </EnterprisePageTrackingWrapper>
      </EnterprisePageTemplateWrapper>
    </EnterprisePageDataProvider>
  );
};

export default ProgramSkillSetRecommendationsPageRoot;
